import {Component, OnInit} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material';
import {EventsService} from '../events.service';
import {HttpClient} from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
import {environment} from '../../environments/environment';
import {AddEventPopUpComponent} from '../add-event-pop-up/add-event-pop-up.component';
import {EventPopUpComponent} from '../event-pop-up/event-pop-up.component';
import * as moment from 'moment';

@Component({
  selector: 'app-main-view',
  templateUrl: './main-view.component.html',
  styleUrls: ['./main-view.component.scss']
})
export class MainViewComponent implements OnInit {

  weekDays = [];
  items: any;
  currentDate: any;

  onIframe = false;

  constructor(private dialog: MatDialog,
              private eventsService: EventsService,
              private _http: HttpClient,
              private route: ActivatedRoute,
              private state: Router) {

    if (window.frameElement) {
      this.onIframe = true;
    }
  }

  ngOnInit() {
    this._http.get(environment.pingEndpoint).subscribe(
      result => {
        console.log(result);
      },
      fail => {
        console.log(fail);
      }
    );
    this.eventsService.getEvents().subscribe(res => {
      // @ts-ignore
      this.items = res.data;
      // @ts-ignore
      this.eventsService.setAuthenticated(!res.auth_required);
      this.currentDate = new Date(this.route.snapshot.params.calendar) || new Date();
      this.getWeekByDate(this.currentDate);
    });

  }

  openPreviewPopUp(data) {
    const popUp: MatDialogRef<AddEventPopUpComponent> = this.dialog.open(AddEventPopUpComponent, {
      width: '600px',
      disableClose: false,
      panelClass: data.video ? 'preview-container' : 'modal-container',
      data: data
    });
  }

  openAddEventPopUp() {
    const popUp: MatDialogRef<EventPopUpComponent> = this.dialog.open(EventPopUpComponent, {
      width: '700px',
      disableClose: false
    });

    popUp.afterClosed().subscribe(data => {
      console.log(data);
    });
  }

  getWeekNumber() {
    return moment(this.currentDate).week();
  }


  getWeekByDateOld(date) {
    const week = moment(date).week();
    this.weekDays = [];
    const weekStart = moment().year(date.getFullYear()).week(week).day('sunday');

    for (let i = 0; i < 7; i++) {
      this.weekDays.push(moment(weekStart).add(i, 'days'));
    }
  }

  //Adding Support for next year
  getWeekByDate(date) {
    const week = moment(date).week();
    this.weekDays = [];
    const year = new Date().getFullYear();
    let weekStart = null;

    if (date.getFullYear() > year) {
      weekStart = moment().year(date.getFullYear() - 1).week(week).day('sunday');
    } else {
      weekStart = moment().year(date.getFullYear()).week(week).day('sunday');
    }

    for (let i = 0; i < 7; i++) {
      this.weekDays.push(moment(weekStart).add(i, 'days'));
    }
  }


  setWeekToToday() {
    const date = new Date();
    this.getWeekByDate(date);
    this.currentDate = date;
    this.state.navigate([`/${moment(date).format('YYYY-MM-DD')}`]);
  }

  setNextWeek() {
    const date = moment(this.currentDate).add(7, 'days').toDate();
    this.getWeekByDate(date);
    this.currentDate = date;
    this.state.navigate([`/${moment(date).format('YYYY-MM-DD')}`]);
  }

  setBeforeWeek() {
    const date = moment(this.currentDate).subtract(7, 'days').toDate();
    this.getWeekByDate(date);
    this.currentDate = date;
    this.state.navigate([`/${moment(date).format('YYYY-MM-DD')}`]);
  }

  getMonth() {
    return moment(this.currentDate).format('MMMM, YYYY');
  }

  isToday(date) {
    return moment(date).isSame(moment().startOf('day'), 'd');
  }

  getWeekDay(date) {
    return moment(date).format('dddd');
  }

  getWeekDayNumber(date) {
    return moment(date).format('D');
  }

  getItemsForDay(date) {
    const _date = moment(date).format('MM/DD/YY');
    return this.items[_date];
  }

}
